import * as ERRORS from 'Reducers/Errors/const'

const initState = {
  apiErrors: [],
}

export function errors(state = initState, action) {
  switch (action.type) {
    case ERRORS.PUSH_API_ERROR:
      return {
        ...state,
        apiErrors: [...state.apiErrors, action.error],
      }

    case ERRORS.REMOVE_OLDEST_API_ERROR:
      return {
        ...state,
        apiErrors: [...state.apiErrors.slice(1)],
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Errors/reducer.js